// dependencies
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, getMatchedRouteKeyValue } from "yarrr";

// components

// selectors

// actions

// css
import css from "./Navigation";

const Navigation = (props) => {
	const { userID, activeView } = props;

	const navigation = [
		{ name: "breadcrumbs", label: "Breadcrumbs", href: `/breadcrumbs/${userID}/` },
		{ name: "asap-notifications", label: "ASAP Notifications", href: `/breadcrumbs/${userID}/asap-notifications` },
		{
			name: "daily-notifications",
			label: "Daily Notifications",
			href: `/breadcrumbs/${userID}/daily-notifications`,
		},
		{ name: "admin-digest", label: "Admin Weekly Digest", href: `/breadcrumbs/${userID}/admin-digest` },
	];

	return (
		<div className={css.main}>
			<div testid="wrapper" className={css.navigationItems}>
				{navigation.map((item) => {
					const isActive = activeView === item.name;

					return (
						<Link
							key={item.name}
							href={item.href}
							className={`${css.navigationItem} ${isActive ? css.isActive : ""}`}
						>
							{item.label}
						</Link>
					);
				})}
			</div>
		</div>
	);
};

Navigation.propTypes = {
	activeView: PropTypes.string.isRequired,
	userID: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
	const view = getMatchedRouteKeyValue(state, "view");
	const userID = getMatchedRouteKeyValue(state, "userID");

	return {
		userID,
		activeView: view || "breadcrumbs",
	};
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
